<template>
    <loading v-if="isLoading" />
    <v-form v-else class="form" v-model="isFormValid">
        <v-container>
            <h1 v-if="!isRegisterFailed" class="base-header display-1 text-center pa-8">
                Save your user
            </h1>
            <h1 v-else class="error-header display-1 text-center pa-8" align="center">
                Unsuccessful registration
            </h1>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card class="elevation-12 rounded register-card mt-n6">
                            <v-col>
                                <v-text-field v-model="name" label="Username" disabled></v-text-field>
                            </v-col>

                            <v-col>
                                <v-text-field v-model="email" label="Email" disabled></v-text-field>
                            </v-col>

                            <v-col>
                                <v-text-field
                                    v-model="password"
                                    :append-icon="passwordIconName"
                                    placeholder=" "
                                    :rules="passwordRules"
                                    :type="passwordType"
                                    label="Password"
                                    @click:append="isEyeShown = !isEyeShown"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col align="center" justify="center">
                                <v-btn class="mb-4 mt-n4" color="secondary" width="100%" @click="registerUser()" :disabled="!isFormValid">
                                    Save
                                </v-btn>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-form>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import { VueReCaptcha } from 'vue-recaptcha-v3';
    import Loading from '@/components/layouts/Loading.vue';

    export default {
        components: {
            Loading,
        },
        props: {
            name: {
                type: String,
                default: null,
            },
            email: {
                type: String,
                default: null,
            },
            token: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                isFormValid: false,
                isEyeShown: false,
                isRegisterFailed: false,
                password: '',
                passwordRules: [
                    (value) => !!value || 'Password is required',
                    (value) => {
                        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
                        return pattern.test(value) || 'At least 8 characters, min one number, min one lowercase, min one uppercase!';
                    },
                ],
            };
        },

        computed: {
            ...mapGetters({
                isLoading: ['getIsLoading'],
            }),

            passwordIconName() {
                return this.isEyeShown ? 'mdi-eye' : 'mdi-eye-off';
            },

            passwordType() {
                return this.isEyeShown ? 'text' : 'password';
            },
        },

        mounted() {
            VueReCaptcha(Vue, {
                siteKey: '6LfPGsYZAAAAACE2WHxYf9EciWjainVT7Gi0vPZU',
            });
        },

        methods: {
            ...mapActions(['register/', 'fetchPassword']),

            registerUser() {
                this.fetchPassword({
                    password: this.password,
                    email: this.email,
                    token: this.token,
                    name: this.name,
                })
                    .then(() => {
                        this.$router.push({
                            name: 'SelectSheetPage',
                        });
                    })
                    .catch(() => {
                        this.isRegisterFailed = true;
                    });
            },
        },
    };
</script>

<style scoped>
    .base-header {
        font-family: Bariol !important;
        font-style: normal;
        font-weight: bold;
        letter-spacing: 0.5px !important;
    }

    .error-header {
        font-family: Bariol !important;
        font-style: normal;
        font-weight: bold;
        letter-spacing: 0.5px !important;
        color: red;
    }

    .register-card {
        background: #ffffff !important ;
        box-shadow: 2px 1px 10px rgba(205, 205, 212, 0.1) !important;
        border-radius: 20px !important;
        filter: drop-shadow(2px 1px 10px rgba(162, 162, 162, 0.25));
    }
</style>
